<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Select Workflow</h3>
    </div>
  </div>
  <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
    <div class="container">
      <div vlass="row">
        <div>
          <mat-form-field appearance="fill" class="example-full-width">
            <mat-label translate="WORKFLOW_GROUP.WORKFLOW_GROUP">Workflow group</mat-label>
            <input matInput [matAutocomplete]="auto" [formControl]="workflowGroupInput" />
          </mat-form-field>
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="workflowGroupSelected()"
            [displayWith]="displayFn"
          >
            <mat-option *ngFor="let group of workflowGroupList" [value]="group">
              <span>{{ group.name }}</span>
            </mat-option>
          </mat-autocomplete>
        </div>
        <div *ngIf="workflowGroupInput.value !== null">
          <mat-form-field appearance="fill" class="example-full-width">
            <mat-label translate="WORKFLOW.WORKFLOWS">Workflow</mat-label>
            <input matInput [matAutocomplete]="auto2" [formControl]="workflowInput" />
          </mat-form-field>
          <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let workflow of workflowList" [value]="workflow">
              <span>{{ workflow.name }}</span>
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button mat-button mat-dialog-close>Cancel</button>
        <button
          [disabled]="workflowInput.value === null"
          mat-raised-button
          color="primary"
          [mat-dialog-close]="{
            group_id: workflowGroupInput.value ? workflowGroupInput.value.id : null,
            workflow_id: workflowInput.value ? workflowInput.value.id : null
          }"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
